import { useState, useEffect, useRef } from 'react';

type Term = { value: string | undefined; [key: string]: any };

export const useDebounce = (
  fn: (data: Term | undefined) => void,
  time = 300
) => {
  const timeout = useRef<NodeJS.Timeout>();

  const [term, setTerm] = useState<Term>();

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      if (term?.value !== undefined) {
        fn(term);
      }
    }, time);

    return () => {
      timeout.current && clearTimeout(timeout.current);
    };
  }, [term, time]);

  return [setTerm];
};
